<div [class.context-alt]="contextAlt" class="container-dropdown">
  <ng-content></ng-content>
</div>
